import React from 'react';
import WidgetBodyWrapper from '../WidgetBodyWrapper';

const Body = (props) => {
  return (
    <WidgetBodyWrapper { ...props } />
  );
};

export default Body;
